/**
 * Policy summaries patients accept (ACCT-03): shown in place on the consent screen after
 * sign-in. Same wording as the mobile app's Legal screen (patientapp LegalScreen.tsx) — keep the
 * two in step until the documents are served from one place.
 */

export interface PolicySection {
  heading: string;
  text: string;
}

export interface Policy {
  title: string;
  updated: string;
  body: PolicySection[];
}

export const POLICIES: Record<"privacy" | "terms", Policy> = {
  privacy: {
    title: "Privacy Policy",
    updated: "01 Jun 2026",
    body: [
      {
        heading: "Data we collect",
        text: "We collect your name, contact details, prescriptions, and order history to provide care. Government IDs are stored separately and encrypted.",
      },
      {
        heading: "How we use it",
        text: "Your data is used to digitise prescriptions, fulfil orders, send reminders, and provide support. We never sell your personal data.",
      },
      {
        heading: "Your rights (DPDP)",
        text: "You can access, export, or request deletion of your data at any time from Settings. Requests are handled per the DPDP Act.",
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    updated: "01 Jun 2026",
    body: [
      {
        heading: "Using the app",
        text: "You must provide accurate information and only upload prescriptions you are authorised to use. Misuse may lead to suspension.",
      },
      {
        heading: "Medicines & orders",
        text: "Orders are reviewed by a licensed pharmacist before fulfilment. Schedule H1/X medicines require a valid prescription and Government ID.",
      },
      {
        heading: "Liability",
        text: "We facilitate ordering from partner pharmacies. Always follow your doctor’s advice; the app is not a substitute for medical care.",
      },
    ],
  },
};
